<template>
  <div class="my-courses-page">
    <h1>My Profile</h1>
    <div class="content">
      <aside class="sidebar">
        <ul>
          <router-link :to="'/my-profile'"
            ><li class="active">My profile</li></router-link
          >
          <router-link :to="'/my-courses'"><li>Online Tutorials</li></router-link>
          <router-link :to="'/live-courses'"><li>Live courses</li></router-link>
          <router-link :to="'/my-requests'"><li>My requests</li></router-link>
        </ul>
      </aside>
      <div class="user-profile">
       <div class="profile-info">
          <p><strong>First Name:</strong> {{ profile.first_name }}</p>
          <p><strong>Last Name:</strong> {{ profile.last_name }}</p>
          <p><strong>Email:</strong> {{ profile.email }}</p>
          <p><strong>Phone:</strong> {{ profile.phone }}</p>
          <p><strong>Country:</strong> {{ profile.country }}</p>
          <p>
            <strong>Status:</strong>
            {{ profile.status === 1 ? "Active" : "Inactive" }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      profile: {},
    };
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleString();
    },
    async getProfile() {
      try {
        const response = await axios.get("user");
        this.profile = response.data.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style scoped>
a {
  color: #fff;
  text-decoration: none;
}
.link {
  text-decoration: underline;
}
.my-courses-page {
  margin: 0 auto 2rem;
  text-align: left;
  font-family: 'Gothic';
}
.my-courses-page h1 {
  text-align: center;
  font-family: 'GothicB';
  padding: 3rem 0;
  background-color: #0e1332;
  color: #fff;
  font-size: 1.5rem;
}
.content {
  margin-top: 2rem;
  display: flex;
  gap: 2rem;
}

/* Sidebar */
.sidebar {
  flex: 1;
}
.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.sidebar ul li {
  padding: 0.75rem 1rem 0.75rem 4rem;
  cursor: pointer;
  font-size: 1rem;
}
.sidebar ul li.active {
  color: orange;
  font-weight: bold;
}

/* Responsive Design */
@media (max-width: 768px) {
  .content {
    flex-direction: column;
  }

  .sidebar ul {
    text-align: center;
  }

  .sidebar ul li {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  .my-courses-page h1 {
    font-size: 1.2rem;
    padding: 1rem 0;
  }

  .sidebar ul li {
    font-size: 0.85rem;
    padding: 0.5rem;
  }
}
.user-profile {
  width: max-content;
  margin: 20px auto;
  min-width: 360px;
  flex: 4;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.profile-info {
  display: flex;
  flex-direction: column;
}

.profile-info p {
  font-size: 1.1em;
  line-height: 1.6;
}

strong {
  display: inline-block;
  min-width: 130px;
  font-family: 'GothicB';
}

h1 {
  text-align: center;
  margin-bottom: 20px;
}
</style>
